import * as React from 'react';
import {styled} from '@mui/material/styles';
import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material/Checkbox';
import {CheckIcon, CheckedOrange, UnCheckIcon} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Box, FormControlLabel, Typography} from '@mui/material';
import {VersionVariants} from '@jobseeker/lotus/enums';

const IconImage = styled(Image)(({theme}) => ({
  '.Mui-focusVisible &': {
    outline: '2px auto',
    outlineColor: theme.palette.primary.light,
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    // cursor: 'not-allowed !important',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)',
  },
}));
type MuiCheckboxPropsModified = Omit<MuiCheckboxProps, 'size'>;
interface CheckboxProps extends MuiCheckboxPropsModified {
  size?: number;
  label?: any;
  variant?: VersionVariants;
  fullWidth?: boolean;
}
function Checkbox({size, label, sx, ...props}: CheckboxProps) {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          sx={{
            '&.MuiCheckbox-root':
              props.variant === VersionVariants.VERSION_HIRIST
                ? {
                    padding: 0,
                  }
                : {},
            '&:hover': {bgcolor: 'transparent'},
            width: 'fit-content',
            ...sx,
          }}
          disableRipple
          color="default"
          checkedIcon={
            <Image
              width={size ?? 20}
              height={size ?? 20}
              src={
                props.variant === VersionVariants.VERSION_HIRIST
                  ? CheckedOrange
                  : CheckIcon
              }
              alt="checkedIcon"
              style={{
                backgroundColor:
                  props.variant === VersionVariants.VERSION_HIRIST
                    ? 'transparent'
                    : '#fff',
              }}
            />
          }
          icon={
            <IconImage
              width={size ?? 20}
              height={size ?? 20}
              src={UnCheckIcon}
              style={{backgroundColor: props.disabled ? '#EFEFEF' : '#fff'}}
              alt="UnCheckIcon"
            />
          }
          // inputProps={{}}
          {...props}
        />
      }
      label={<Box width={props.fullWidth ? '100%' : 'auto'}>{label}</Box>}
      sx={{width: isAppIimjobs || !props.fullWidth ? 'auto' : '100%', ...sx}}
    />
  );
}

export default Checkbox;
